'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icons = require('../../Icons');

var _Icons2 = _interopRequireDefault(_Icons);

var _ComingSoonLabel = require('../../ComingSoonLabel');

var _ComingSoonLabel2 = _interopRequireDefault(_ComingSoonLabel);

var _urlLocations = require('../../../routes/urlLocations');

var _place = require('../../../constants/place');

var _place2 = _interopRequireDefault(_place);

var _Menu = require('../../Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _styledComponents = require('styled-components');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Menu = (0, _Menu2.default)({
  place: _place2.default.Header
});

var UnAuthorizedMenu = function UnAuthorizedMenu(props) {
  var hideStatic = props.hideStatic;
  var iconStyles = {
    color: props.theme.platformPrimary
  };
  return _react2.default.createElement(Menu.Wrapper, null, _react2.default.createElement(Menu.List, null, _react2.default.createElement(Menu.Item, {
    unAuthorizedMenuItem: true,
    headerDisabled: true,
    firstHeaderDisabled: true,
    key: 'comingSoon'
  }, _react2.default.createElement(Menu.NavLink, {
    headerDisabled: true,
    to: '#'
  }, _react2.default.createElement(_ComingSoonLabel2.default, null, 'Coming Soon'))), _react2.default.createElement(Menu.Item, {
    headerDisabled: true,
    key: 'homeSubMenu'
  }, _react2.default.createElement(Menu.NavLink, {
    headerDisabled: true,
    to: '#'
  }, _react2.default.createElement(_Icons2.default.card, null), _react2.default.createElement('span', null, 'INVESTOR CLUB'))), !hideStatic && _react2.default.createElement(Menu.Item, {
    headerDisabled: true,
    lastHeaderDisabled: true,
    key: 'tutorialSubMenu'
  }, _react2.default.createElement(Menu.NavLink, {
    headerDisabled: true,
    to: '#'
  }, _react2.default.createElement(_Icons2.default.members, {
    style: iconStyles
  }), _react2.default.createElement('span', null, 'STRATEGIC MEMBERS'))), !hideStatic && _react2.default.createElement(Menu.Item, {
    key: 'partnersSubMenu'
  }, _react2.default.createElement(Menu.NavLink, {
    to: _urlLocations.partners
  }, _react2.default.createElement(_Icons2.default.handBag, {
    style: iconStyles
  }), _react2.default.createElement('span', null, 'PARTNERS'))), !hideStatic && _react2.default.createElement(Menu.Item, {
    key: 'aboutUsSubMenu'
  }, _react2.default.createElement(Menu.NavLink, {
    to: _urlLocations.about
  }, _react2.default.createElement(_Icons2.default.info, {
    style: iconStyles
  }), _react2.default.createElement('span', null, 'ABOUT FINBURSA'))), _react2.default.createElement(Menu.Item, {
    key: 'userSubMenu'
  }, _react2.default.createElement(Menu.NavLink, {
    to: _urlLocations.login
  }, _react2.default.createElement(_Icons2.default.user, {
    style: iconStyles
  }), _react2.default.createElement('span', null, 'LOGIN')))));
};

exports.default = (0, _styledComponents.withTheme)(UnAuthorizedMenu);